import VueCookies from "vue-cookies";

require('es6-promise').polyfill();
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './lang/setup'
import VueGtag from "vue-gtag";
import TextareaAutosize from 'vue-textarea-autosize'
import './assets/scss/fonts.css'

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { parseInviteCodesFromUri, formatDate } from './utils';
import { SET_INVITE_CODES } from './store/mutationTypes';
import VueMatomo from 'vue-matomo'

const matomoConfigs = {
  stockholm: {
    siteId: '5',
    cookieDomain: ".fotografiska.com",
    domains: [
      "stockholm.fotografiska.com",
      "shop-stockholm.fotografiska.com",
      "tickets-sto.fotografiska.com",
      "members-sto.fotografiska.com",
    ],
  },
  new_york: {
    siteId: '4',
    cookieDomain: ".fotografiska.com",
    domains: [
      "newyork.fotografiska.com",
      "shop-newyork.fotografiska.com",
      "tickets-ny.fotografiska.com",
      "members-ny.fotografiska.com",
    ],
  },
  berlin: {
    siteId: '3',
    cookieDomain: ".fotografiska.com",
    domains: [
      "berlin.fotografiska.com",
      "tickets-berlin.fotografiska.com",
      "shop-berlin.fotografiska.com",
      "members-berlin.fotografiska.com",
    ],
  },
};
const matomoBranchConfig = matomoConfigs[process.env.FG_APP_BRANCH] || {};

Vue.use(VueMatomo, {
  host: 'https://fotografiska.matomo.cloud/',
  ...matomoBranchConfig,
  router: router,
});

Vue.use(VueTelInput, {
  // inputOptions: {
  //   showDialCode: false
  // },
  dropdownOptions: {
    showDialCodeInList: false,
    width: '248px',
  }
});
Vue.use(VueGtag, {
  config: { id: process.env.GTAG_ID }
});
Vue.use(TextareaAutosize)

Vue.use(VueCookies)
Vue.$cookies.config('7d', '/', process.env.FG_AUTH_COOKIE_DOMAIN)

Vue.mixin({
  methods: {
    formatDate,
  }
})

Vue.config.productionTip = false

Vue.prototype.$appBranch = process.env.FG_APP_BRANCH;

function isUpgradeWallHidden(store) {
  return store.getters.hideUpgradeWallUntil && (new Date()).getTime() < store.getters.hideUpgradeWallUntil
}

router.beforeEach(async (to, from, next) => {

  if ('coupon' in to.query && to.query.coupon!='') {
    store.dispatch('setPresetMembershipCouponCode', to.query.coupon)
  }
  if ('invite' in to.query && to.query.invite!='') {
    const codes = parseInviteCodesFromUri(to.query.invite)
    if (codes && codes.length > 0) {
      store.commit(SET_INVITE_CODES, codes)
    }
  }

  const tokenInCookie = Vue.$cookies.get(process.env.FG_AUTH_COOKIE_TOKEN);
  const userInCookie = Vue.$cookies.get(process.env.FG_AUTH_COOKIE_USER);
  if (tokenInCookie && userInCookie && !store.getters.isLoggedIn) {
    await store.dispatch('loginViaToken', {token: tokenInCookie, userId: userInCookie.id})
    store.dispatch('setHideUpgradeWall', false)
  }

  if (('fg_user_token' in to.query && 'fg_user_id' in to.query)) {
    await store.dispatch('loginViaToken', {token: to.query.fg_user_token, userId: to.query.fg_user_id})
    store.dispatch('setHideUpgradeWall', false)
  }

  if (store.getters.isLoggedIn) {
    // let's see if there are any updates to the current user object
    await store.dispatch('loadCurrentUser')
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAccessCode = to.matched.some(record => record.meta.requiresAccessCode)
  const requiresMembership = to.matched.some(record => record.meta.requiresMembership)
  const requiresUnauth = to.matched.some(record => record.meta.requiresUnauth)

  const hasAuth = store.getters.isLoggedIn == true
  const hasMembership = store.getters.currentUser && store.getters.currentUser.membership

  const upgradeWallHidden = isUpgradeWallHidden(store);
  const upgradeNeeded = store.getters.currentUser &&
    store.getters.currentUser.upgradeNeeded;
  const isUpgradeGracePeriod = store.getters.currentUser &&
    store.getters.currentUser.isUpgradeGracePeriod;

  // const upgradeDone = store.getters.currentUser &&
  //   store.getters.currentUser.membership &&
  //   store.getters.currentUser.membership &&
  //   store.getters.currentUser.membership.newMembershipType != null;

  const hasAccessCode = store.getters.hasMembershipAccess


  if (('tickets' in to.query)) {
    store.dispatch('setTicketsUri', to.query.tickets)
  }

  if (hasAuth && requiresUnauth) {
    next({path: '/'})
    return
  }

  if (requiresAuth || requiresAccessCode || requiresMembership) {
    if (requiresAuth && !hasAuth) {
      const query = to.fullPath != '' && to.fullPath != '/' ? {redirect: to.fullPath} : {}
      next({
        path: `/signup/login`,
        query
      })
      return
    }

    if (requiresAccessCode && !hasAccessCode) {
      // TODO: add message
      next({
        path: '/'
      })
      return
    }

    if (requiresMembership && !hasMembership) {
      // TODO: add Message
      next({
        path: '/'
      })
      return
    }

    //
    if (requiresAuth && to.name != 'upgrade' && (upgradeNeeded || isUpgradeGracePeriod) && !upgradeWallHidden) {
      const query = to.fullPath != '' && to.fullPath != '/' ? {redirect: to.fullPath} : {}
      next({
        path: '/upgrade',
        query
      })
      return
    }

    if (to.name == 'upgrade' && !(upgradeNeeded || isUpgradeGracePeriod) && !('preview' in to.query)) {
      next({
        path: '/',
      })
      return
    }

    next()

  } else {
    next() // make sure to always call next()!
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
